import { START_LOADING, GET_THEMES, DELETE_THEME, EDIT_THEME, CREATE_THEME, STOP_LOADING, ERROR } from "../ThemesAction/types";


const INITIAL_STATE = {
  loading: false,
  success: false,
  message_valid: false
}

export default function (state = INITIAL_STATE, action) {

  switch (action.type) {
    case GET_THEMES:
      return {
        ...state,
        themes_list: action.payload,
        loading: false,
        success: false
      }
    case START_LOADING:
      return {
        ...state,
        loading: true
      }
    case CREATE_THEME:
      return {
        ...state,
        new_theme: action.payload,
        loading: false
      }
    case EDIT_THEME:
      return {
        ...state,
        edited_theme: action.payload,
        loading: false
      }
    case DELETE_THEME:
      return {
        ...state,
        success: true,
        loading: false
      }
    case STOP_LOADING:
      return {
        ...state,
        loading: false
      }
    case ERROR:
      return {
        ...state,
        error_message: action.payload,
        message_valid: !state.message_valid,
        loading: false
      }
    default:
      return {
        ...state
      }
  }
}